<div class="page-container">

  <div class="page-header">
    <div class="header-left">
      <button
        mat-icon-button
        (click)="goBack()"
        matTooltip="Retour à la liste">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div class="header-info">
        <h2 class="header-title">
          Évaluation de compétences de
          {{ getCivilite() }}
          {{ evaluation?.nom | uppercase }}
          {{ evaluation?.prenom }}
        </h2>

        <span class="header-sub">
          {{ evaluation?.application }}

          <span *ngIf="evaluation?.uniteOrganisationnelle">
            · {{ evaluation?.uniteOrganisationnelle?.code }}
          </span>

          <span *ngIf="evaluation?.dateDemarrage">
            · Démarrage :
            {{ evaluation?.dateDemarrage | date:'dd/MM/yyyy' }}
          </span>

          <span class="date-fmc-inline">
            · Fin montée en compétences :

            <!-- Mode affichage -->
            <ng-container *ngIf="!isEditingDateFmc">
              <span>
                {{
                  evaluation?.dateFinMonteeCompetence
                    ? (evaluation?.dateFinMonteeCompetence | date:'dd/MM/yyyy')
                    : '—'
                }}
              </span>

              <button
                mat-icon-button
                class="btn-edit-date"
                *ngIf="evaluation?.status !== 'ARCHIVEE'"
                (click)="startEditDateFmc()"
                [disabled]="isSaving"
                matTooltip="Modifier la date de fin de montée en compétences">
                <mat-icon>edit_calendar</mat-icon>
              </button>
            </ng-container>

            <!-- Mode édition -->
            <ng-container *ngIf="isEditingDateFmc">
              <mat-form-field
                appearance="outline"
                class="date-fmc-field">

                <input
                  matInput
                  [matDatepicker]="pickerFinMontee"
                  [(ngModel)]="dateFmcEdit"
                  (click)="pickerFinMontee.open()"
                  readonly>

                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickerFinMontee">
                </mat-datepicker-toggle>

                <mat-datepicker #pickerFinMontee>
                </mat-datepicker>
              </mat-form-field>

              <button
                mat-icon-button
                color="primary"
                class="btn-date-action"
                (click)="saveDateFmc()"
                [disabled]="isSaving || !dateFmcEdit"
                matTooltip="Enregistrer">
                <mat-icon>check</mat-icon>
              </button>

              <button
                mat-icon-button
                class="btn-date-action"
                (click)="cancelEditDateFmc()"
                [disabled]="isSaving"
                matTooltip="Annuler">
                <mat-icon>close</mat-icon>
              </button>
            </ng-container>
          </span>
        </span>
      </div>
    </div>

    <div class="header-right">
      <span
        class="badge-statut"
        *ngIf="evaluation"
        [ngClass]="{
          'statut-brouillon': evaluation.status === 'BROUILLON',
          'statut-validee': evaluation.status === 'VALIDEE',
          'statut-archivee': evaluation.status === 'ARCHIVEE'
        }">
        {{ evaluation.status }}
      </span>

      <button
        mat-stroked-button
        *ngIf="evaluation?.status !== 'ARCHIVEE'"
        (click)="ouvrirAjoutCriteres()"
        [disabled]="isSaving"
        matTooltip="Ajouter de nouveaux critères à évaluer">
        <mat-icon>playlist_add</mat-icon>
        Ajouter des critères
      </button>

      <button
        mat-stroked-button
        color="primary"
        *ngIf="evaluation?.status !== 'ARCHIVEE'"
        (click)="enregistrer()"
        [disabled]="isSaving || pendingNotes.size === 0">
        <mat-icon>save</mat-icon>

        Enregistrer

        <span *ngIf="pendingNotes.size > 0">
          ({{ pendingNotes.size }})
        </span>
      </button>

      <button
        mat-raised-button
        color="primary"
        *ngIf="evaluation?.status === 'BROUILLON'"
        (click)="valider()"
        [disabled]="isSaving || !canValider()"
        [matTooltip]="
          !canValider()
            ? getValidationErrors().join(' · ')
            : 'Valider l\'évaluation'
        ">
        <mat-icon>check_circle</mat-icon>
        Valider
      </button>

      <button
        mat-raised-button
        *ngIf="evaluation?.status === 'VALIDEE' && isAdmin"
        (click)="archiver()"
        [disabled]="isSaving"
        class="btn-archive">
        <mat-icon>archive</mat-icon>
        Archiver
      </button>

      <button
        mat-stroked-button
        color="primary"
        *ngIf="evaluation?.status !== 'ARCHIVEE'"
        (click)="addMois()"
        [disabled]="isSaving || !canAddMois()"
        [matTooltip]="getMoisBlockedTooltip()">
        <mat-icon>add</mat-icon>
        Ajouter M+{{ (evaluation?.mois?.length || 0) + 1 }}
      </button>
    </div>
  </div>

  <!-- Bannière évaluation archivée -->
  <div
    *ngIf="evaluation?.status === 'ARCHIVEE'"
    class="readonly-banner">
    <mat-icon>lock</mat-icon>
    Cette évaluation est archivée — consultation uniquement.
  </div>

  <!-- Bannière des erreurs de validation -->
  <div
    *ngIf="
      evaluation?.status === 'BROUILLON'
      && getValidationErrors().length > 0
    "
    class="validation-banner">

    <mat-icon>info_outline</mat-icon>

    <span>Pour valider : </span>

    <span
      *ngFor="
        let err of getValidationErrors();
        let last = last
      ">
      {{ err }}

      <span *ngIf="!last">
        ·
      </span>
    </span>
  </div>

  <!-- Navigation entre les mois -->
  <div
    class="mois-nav"
    *ngIf="evaluation && evaluation.mois.length > 0">

    <span class="mois-nav-label">
      <mat-icon>filter_list</mat-icon>
      Aller au mois :
    </span>

    <div class="mois-nav-chips">
      <span
        *ngFor="
          let mois of getMoisList();
          trackBy: trackByMoisId
        "
        class="mois-nav-chip"
        (click)="scrollToMois(mois.moisIndex)"
        matTooltip="
          M{{ mois.moisIndex }}
          — {{ mois.dateReference | date:'MMMM yyyy' }}
        ">

        M{{ mois.moisIndex }}

        <span
          *ngIf="mois.dateReference"
          class="mois-nav-date">
          {{ mois.dateReference | date:'MM/yy' }}
        </span>
      </span>
    </div>
  </div>

  <!-- Tableau des évaluations -->
  <div
    class="table-scroll-wrapper"
    #tableWrapper
    *ngIf="evaluation">

    <table
      mat-table
      [dataSource]="tableRows"
      class="eval-mat-table mat-elevation-z2">

      <!-- Colonne catégorie -->
      <ng-container
        matColumnDef="categorie"
        sticky>

        <th
          mat-header-cell
          *matHeaderCellDef
          class="col-categorie">
          Catégorie
        </th>

        <td
          mat-cell
          *matCellDef="let row"
          class="col-categorie">

          <span *ngIf="row.showCategorie">
            {{ row.categorie }}
          </span>
        </td>
      </ng-container>

      <!-- Colonne critère -->
      <ng-container
        matColumnDef="critere"
        sticky>

        <th
          mat-header-cell
          *matHeaderCellDef
          class="col-critere">
          Critère
        </th>

        <td
          mat-cell
          *matCellDef="let row"
          class="col-critere">
          {{ row.ligne.critereSnapshot }}
        </td>
      </ng-container>

      <!-- Colonne note cible -->
      <ng-container matColumnDef="cible">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="col-note col-cible">
          Note cible fin montée en
          <br>
          compétences
        </th>

        <td
          mat-cell
          *matCellDef="let row"
          class="col-note col-cible">

          <app-note-cell
            [note]="getNote(row.ligne, 'CIBLE')"
            [readonly]="evaluation.status === 'ARCHIVEE'"
            (noteChange)="onNoteChange(row.ligne, 'CIBLE', null, $any($event))">
          </app-note-cell>
        </td>
      </ng-container>

      <!-- Colonne note au démarrage -->
      <ng-container matColumnDef="demarrage">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="col-note col-demarrage">
          Note au démarrage de mission
        </th>

        <td
          mat-cell
          *matCellDef="let row"
          class="col-note col-demarrage">

          <app-note-cell
            [note]="getNote(row.ligne, 'DEMARRAGE')"
            [readonly]="evaluation.status === 'ARCHIVEE'"
            (noteChange)="onNoteChange(row.ligne, 'DEMARRAGE', null, $any($event))">
          </app-note-cell>
        </td>
      </ng-container>

      <!-- Colonne note de fin -->
      <ng-container matColumnDef="fin">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="col-note col-fin">
          Note fin de montée en
          <br>
          compétences
        </th>

        <td
          mat-cell
          *matCellDef="let row"
          class="col-note col-fin">

          <app-note-cell
            [note]="getNote(row.ligne, 'FIN')"
            [readonly]="evaluation.status === 'ARCHIVEE'"
            (noteChange)="onNoteChange(row.ligne, 'FIN', null, $any($event))">
          </app-note-cell>
        </td>
      </ng-container>

      <!-- Colonnes mensuelles dynamiques -->
      <ng-container
        *ngFor="
          let mois of getMoisList();
          trackBy: trackByMoisId
        "
        [matColumnDef]="getMoisColumnId(mois)">

        <th
          mat-header-cell
          *matHeaderCellDef
          class="col-note th-mois"
          [id]="'col-mois-' + mois.moisIndex">

          <div class="mois-header">
            <span class="mois-label">
              M+{{ mois.moisIndex }}
            </span>

            <span
              class="mois-date"
              *ngIf="mois.dateReference">
              {{ mois.dateReference | date:'MM/yyyy' }}
            </span>
          </div>
          <button class="btn-delete-mois"
                  *ngIf="evaluation.status !== 'ARCHIVEE' && canDeleteMois(mois)"
                  (click)="$event.stopPropagation(); deleteMois(mois)"
                  matTooltip="Supprimer M+{{ mois.moisIndex }}">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </th>

        <td
          mat-cell
          *matCellDef="let row"
          class="col-note">

          <app-note-cell
            [note]="getNoteMensuelle(row.ligne, mois.id)"
            [readonly]="evaluation.status === 'ARCHIVEE'"
            (noteChange)="onNoteChange(row.ligne, 'MENSUELLE', mois.id, $any($event))">
          </app-note-cell>
        </td>
      </ng-container>

      <!-- Lignes du tableau -->
      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns">
      </tr>

      <tr
        mat-row
        class="row-competence"
        *matRowDef="
          let row;
          columns: displayedColumns
        ">
      </tr>
    </table>
  </div>

  <!-- Section commentaire -->
  <div
    class="comment-section"
    *ngIf="evaluation">

    <div class="comment-header">
      <mat-icon>chat_bubble_outline</mat-icon>
      <span>Commentaire</span>
    </div>

    <mat-form-field
      appearance="outline"
      color="accent"
      class="comment-field">

      <textarea
        matInput
        [(ngModel)]="commentaireEdit"
        [disabled]="evaluation.status === 'ARCHIVEE'"
        cdkTextareaAutosize
        cdkAutosizeMinRows="2"
        cdkAutosizeMaxRows="6"
        placeholder="Ajouter une note ou un commentaire sur cette évaluation...">
      </textarea>
    </mat-form-field>

    <div
      class="comment-actions"
      *ngIf="evaluation.status !== 'ARCHIVEE'">

      <button
        mat-stroked-button
        color="primary"
        (click)="enregistrerCommentaire()"
        [disabled]="
          isSavingComment
          || commentaireEdit === (evaluation.commentaire ?? '')
        ">
        <mat-icon>save</mat-icon>
        Enregistrer le commentaire
      </button>
    </div>
  </div>

</div>